import { Component, Input } from "@angular/core";
import { FeiraModel } from "../model/event.model";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastService } from "src/app/shared/toasts/toast-service";
import { EventService } from "../event.service";
import { CommonModule } from "@angular/common";
import { SharedModule } from "src/app/shared/shared.module";

@Component({
  selector: "app-event-form",
  standalone: true,
  imports: [CommonModule, SharedModule, ReactiveFormsModule, FormsModule],
  templateUrl: "./event-form.component.html",
  styleUrl: "./event-form.component.scss",
})
export class EventFormComponent {
  @Input() event: FeiraModel | null = null;
  eventForm!: FormGroup;
  loading = false;
  constructor(
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private eventService: EventService,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.eventForm = this.fb.group({
      id: [this.event?.id],
      nome: [this.event?.nome, Validators.required],
    });
  }

  onSubmit(): void {
    if (this.eventForm.invalid) {
      return;
    }
    this.loading = true;
    if (this.event) {
      this.eventService
        .updateEvent(this.event.id!, this.eventForm.value)
        .subscribe({
          next: () => {
            this.toastService.show("Feira atualizada com sucesso", {
              classname: "bg-success text-light",
            });
            this.activeModal.close();
          },
          error: () => {
            this.toastService.show("Erro ao atualizar feira", {
              classname: "bg-danger text-light",
            });
          },
          complete: () => {
            this.loading = false;
          },
        });
    } else {
      this.eventService.createEvent(this.eventForm.value).subscribe({
        next: () => {
          this.toastService.show("Feira criado com sucesso", {
            classname: "bg-success text-light",
          });
          this.activeModal.close();
        },
        error: () => {
          this.toastService.show("Erro ao criar feira", {
            classname: "bg-danger text-light",
          });
        },
        complete: () => {
          this.loading = false;
        },
      });
    }
  }
}
